import { useState } from "react";
import { adminLogin } from "../../api";

export default function Login({ onSuccess }: { onSuccess: (username: string) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      const r = await adminLogin(username.trim(), password);
      onSuccess(r.username);
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : "登入失敗");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="card">
        <img src="/straight-a-logo.png" alt="Straight A" style={{ height: 26, marginBottom: 12 }} />
        <h2>管理後台登入</h2>
        {err && <div className="alert err">{err}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label htmlFor="u">帳號</label>
            <input id="u" value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
          </div>
          <div className="field">
            <label htmlFor="p">密碼</label>
            <input
              id="p"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="btn primary full" disabled={busy}>
            {busy ? "登入中…" : "登入"}
          </button>
        </form>
      </div>
    </div>
  );
}
